<template>
  <div class="previous-review">
    <div class="meeting-container">
      <div class="left-container">
        <a
          :href="item.link"
          target="_blank"
          v-for="(item,index) in previousList"
          :key="index"
          @mouseover="active=index"
          @mouseout="active=100"
          class="yearLink"
        >
          <img :src="item.defaultImage" class="year" />
          <img :src="item.arrow" class="arrow" />
        </a>
      </div>
      <img :src="image" />
    </div>
    <!--    <div class="logo-container"-->
    <!--         style="width: 100vw;height: 100vh;display: flex;justify-content: center;align-items: center;background: #ff3c00">-->
    <!--      <img src="https://summit-img.geekpark.net/ifx/pc/footer-GEEKPARK-LOGO-white.svg" alt=""-->
    <!--           style="width: 24.5vw">-->
    <!--    </div>-->
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "PreviousReview",
  computed: {
    ...mapState({
      image: state => state.previousReview.image,
      previousList: state => state.previousReview.previousList,
      previousListBackup: state => state.previousReview.previousListBackup
    })
  },
  data() {
    return {
      active: 100
    };
  },
  watch: {
    active: function() {
      const active = this.active;
      if (active === 100) {
        this.$store.commit("UPDATE_PREVIOUS_LIST", this.previousListBackup);
      } else {
        const previousListBackup = this.previousListBackup;
        const previousList = JSON.parse(JSON.stringify(this.previousList));
        previousList[active].defaultImage =
          previousListBackup[active].hoverImage;
        previousList[active].arrow = previousListBackup[active].arrowHover;
        this.$store.commit("UPDATE_PREVIOUS_LIST", previousList);
      }
    }
  },
  methods: {}
};
</script>

<style scoped lang="less">
.previous-review {
  display: flex;
  width: auto;
  height: 100vh;
  margin-left: 5vh;

  .meeting-container {
    display: flex;
    height: 86vh;
    margin-top: 7vh;

    .left-container {
      margin-right: 8vh;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .yearLink {
        width: 26vh;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .year {
          width: 20vh;
        }
        &:first-child {
          .year {
            width: 16vh;
          }
        }

        .arrow {
          width: 5vh;
        }
      }
    }

    > img {
      // width: 100vh;
      height: 86vh;
      align-self: center;
      border: 1px solid #f0f0f0;
    }
  }

  .logo-container {
    width: 100vw;
    height: 100vh;
  }
}
</style>
